import { Domain } from 'shared/dikastis-constants';

const routes = {};

// TODO: add some validation
function registerRoute(domain, path, tabs = []) {
  routes[path] = {
    domain,
    tabs: Object.freeze(tabs),
  };
}

function registerGroup(domain, paths, tabs = []) {
  paths.forEach((path) => {
    registerRoute(domain, path, tabs);
  });
}

// TODO: add some validation
// genPath should be a function that generates the path
// and receives the split path as its first argument.
// e.g. [ 'teachers', '1234', '5678' ] for the URL:
// dikastis.com.br/teachers/1234/5678
function makeTab(name, genPath) {
  return {
    genPath,
    name,
  };
}

export const getRoute__UNSAFE = (path) => routes[path];

export const getRoutes = () => Object.freeze(routes);

// ADD ROUTES BELOW THIS LINE
// TODO - change parameters name to match pathname
export const Path = Object.freeze({
  ACCOUNT_ACTIVATION: '/activate-account',
  ACCOUNT_ACTIVATION_RESEND: '/resend-activation',
  CATEGORIES: '/categories',
  ORGANIZATION: '/organizations/:organizationId',
  ORGANIZATIONS_HOME: '/organizations',
  ORGANIZATION_TEAM: '/organizations/:organizationId/:teamId',
  ORGANIZATION_TEAM_TASK: '/organizations/:organizationId/:teamId/:taskId',
  ORGANIZATION_TEAM_TASK_FEEDBACK: '/organizations/:organizationId/:teamId/:taskId/feedback',
  ORGANIZATION_TEAM_TASK_FEEDBACK_PERSON: '/organizations/:organizationId/:teamId/:taskId/feedback/:personId',
  ORGANIZATION_TEAM_TASK_PERSON: '/organizations/:organizationId/:teamId/:taskId/:personId',
  PASSWORD_RECOVERY: '/password-recovery',
  PASSWORD_RECOVERY_REQUEST: '/recovery-request',
  PROBLEMS: '/problems',
  PROBLEMS_MINE: '/problems/mine',
  PROBLEMS_NEW: '/problems/new',
  PROBLEMS_PROBLEM: '/problems/:problemId',
  PROBLEMS_PROBLEM_EDIT: '/problems/:problemId/edit',
  PROBLEMS_PROBLEM_SUBMISSIONS: '/problems/:problemId/submissions',
  PROFILE: '/profile',
  SIGN_IN: '/sign-in',
  SIGN_UP: '/sign-up',
  TEAMS_HOME: '/teams',
  TEAMS_NEW: '/teams/new',
  TEAMS_TEAM: '/teams/:teamId',
  TEAMS_TEAM_EDIT: '/teams/:teamId/edit',
  TEAMS_TEAM_NEW_TASK: '/teams/:teamId/new-task',
  TEAMS_TEAM_TASK: '/teams/:teamId/:taskId',
  TEAMS_TEAM_TASK_EDIT: '/teams/:teamId/:taskId/edit',
  TEAMS_TEAM_TASK_FEEDBACK: '/teams/:teamId/:taskId/feedback',
});

export const DomainEntryPoint = Object.freeze({
  [Domain.HOME]: Path.CATEGORIES,
  [Domain.PROFILE]: Path.PROFILE,
  [Domain.PROBLEMS]: Path.PROBLEMS,
  [Domain.TEAMS]: Path.TEAMS_HOME,
  [Domain.ORGANIZATIONS]: Path.ORGANIZATIONS_HOME,
});

registerRoute(Domain.HOME, Path.CATEGORIES);

registerRoute(Domain.PROFILE, Path.PROFILE);

registerGroup(
  Domain.PROBLEMS,
  [
    Path.PROBLEMS,
    Path.PROBLEMS_MINE,
  ],
  [
    makeTab('All Problems', () => Path.PROBLEMS),
    makeTab('My Problems', () => Path.PROBLEMS_MINE),
  ],
);

registerGroup(
  Domain.PROBLEMS,
  [
    Path.PROBLEMS_PROBLEM,
    Path.PROBLEMS_PROBLEM_SUBMISSIONS,
  ],
  [
    makeTab('Problem', ({ problemId }) => Path.PROBLEMS_PROBLEM.replace(':problemId', problemId)),
    makeTab('Submissions', ({ problemId }) => Path.PROBLEMS_PROBLEM_SUBMISSIONS.replace(':problemId', problemId)),
  ],
);

registerGroup(
  Domain.PROBLEMS,
  [
    Path.PROBLEMS_NEW,
    Path.PROBLEMS_PROBLEM_EDIT,
  ],
);

registerGroup(
  Domain.ORGANIZATIONS,
  [
    Path.ORGANIZATIONS_HOME,
    Path.ORGANIZATION,
    Path.ORGANIZATION_TEAM,
    Path.ORGANIZATION_TEAM_TASK_PERSON,
    Path.ORGANIZATION_TEAM_TASK_FEEDBACK_PERSON,
  ],
);

registerGroup(
  Domain.ORGANIZATIONS,
  [
    Path.ORGANIZATION_TEAM_TASK,
    Path.ORGANIZATION_TEAM_TASK_FEEDBACK,
  ],
  [
    makeTab('Submissions', ({ organizationId, taskId, teamId }) => Path.ORGANIZATION_TEAM_TASK
      .replace(':organizationId', organizationId)
      .replace(':taskId', taskId)
      .replace(':teamId', teamId)),
    makeTab('Feedback', ({ organizationId, taskId, teamId }) => Path.ORGANIZATION_TEAM_TASK_FEEDBACK
      .replace(':organizationId', organizationId)
      .replace(':taskId', taskId)
      .replace(':teamId', teamId)),
  ],
);

registerGroup(
  Domain.TEAMS,
  [
    Path.TEAMS_HOME,
    Path.TEAMS_TEAM_TASK,
    Path.TEAMS_TEAM,
    Path.TEAMS_NEW,
    Path.TEAMS_TEAM_EDIT,
    Path.TEAMS_TEAM_NEW_TASK,
    Path.TEAMS_TEAM_TASK_EDIT,
    Path.TEAMS_TEAM_TASK_FEEDBACK,
  ],
);

registerGroup(
  Domain.TEAMS,
  [
    Path.TEAMS_TEAM_TASK,
    Path.TEAMS_TEAM_TASK_FEEDBACK,
  ],
  [
    makeTab('Problems', ({ taskId, teamId }) => Path.TEAMS_TEAM_TASK
      .replace(':taskId', taskId)
      .replace(':teamId', teamId)),
    makeTab('Feedback', ({ taskId, teamId }) => Path.TEAMS_TEAM_TASK_FEEDBACK
      .replace(':taskId', taskId)
      .replace(':teamId', teamId)),
  ],
);
